import React from 'react'
import './NoteCard.css'
import { TbStar, TbStarFilled, TbTrash } from 'react-icons/tb';

export default function NoteCard({ title, text, date, onClick, onHandleStar, isStarred, onDelete }) {

    const handleStarClick = (e) => {
        e.stopPropagation();      // üstteki onClick yayılmasını durdur
        onHandleStar();           // yıldız state’ini güncelle
    };

    const handleDeleteClick = (e) =>{
        e.stopPropagation();
        onDelete();
    }

    return (
        <div className='note-card' onClick={onClick}>
            <span onClick={handleStarClick} style={{ position: 'absolute', right: '10px' }}>
                {isStarred ? <TbStarFilled className="notebook-header-right-button" size={16} /> : <TbStar className="notebook-header-right-button" size={16} />}
            </span>

            <span style={{ position: 'absolute', right: '10px',bottom:'10px' }} onClick={handleDeleteClick}>
                <TbTrash className="notebook-header-right-button" size={16} />
            </span>
            <span className='note-card-title'>{title}</span>
            <span className='note-card-text'>{text ? text : "..."}</span>
            <span className='note-card-date'>{date}</span>
        </div>
    );
}
